var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWindow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 42,
    viewBox: "0 0 28 42",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 15.7734H15.1666C14.8399 15.7734 14.5599 16.0534 14.5599 16.3801V37.3801C14.5599 37.7068 14.8399 37.9868 15.1666 37.9868H23.3333C23.6599 37.9868 23.9399 37.7068 23.9399 37.3801V16.3334C23.9399 16.0068 23.6599 15.7734 23.3333 15.7734ZM22.7733 36.7734H15.7733V16.9401H22.7733V36.7734Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 15.7734H4.6666C4.33994 15.7734 4.05994 16.0534 4.05994 16.3801V37.3801C4.05994 37.7068 4.33994 37.9868 4.6666 37.9868H12.8333C13.1599 37.9868 13.4399 37.7068 13.4399 37.3801V16.3334C13.4399 16.0068 13.1599 15.7734 12.8333 15.7734ZM12.2733 36.7734H5.27327V16.9401H12.2733V36.7734Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.74 5.27315C8.25999 5.83315 4.71332 9.37982 4.15332 13.8598C4.15332 14.0465 4.19999 14.1865 4.29332 14.3265C4.38665 14.4665 4.57332 14.5132 4.71332 14.5132H12.7867C13.1133 14.5132 13.3933 14.2332 13.3933 13.9065V5.83316C13.3933 5.64649 13.3 5.50649 13.2067 5.41316C13.1133 5.31982 12.9267 5.22649 12.74 5.27315ZM12.2733 13.3465H5.41332C6.11332 9.89315 8.77332 7.23316 12.2267 6.53316V13.3465H12.2733Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 5.27344C15.0734 5.27344 14.9334 5.3201 14.7934 5.41344C14.6534 5.50677 14.6067 5.69344 14.6067 5.83344V13.9068C14.6067 14.2334 14.8867 14.5134 15.2134 14.5134H23.2867C23.4734 14.5134 23.6134 14.4201 23.7067 14.3268C23.8 14.2334 23.8467 14.0468 23.8467 13.8601C23.2867 9.33344 19.74 5.83344 15.26 5.27344ZM15.7734 13.3468V6.53344C19.2267 7.23344 21.8867 9.89344 22.5867 13.3468H15.7734Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.3 0 0 6.3 0 14V40.8333C0 41.4867 0.513333 42 1.16667 42H26.8333C27.4867 42 28 41.4867 28 40.8333V14C28 6.3 21.7 0 14 0ZM25.6667 39.6667H2.33333V14C2.33333 7.56 7.56 2.33333 14 2.33333C20.44 2.33333 25.6667 7.56 25.6667 14V39.6667Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.5599,
    y1: 15.7734,
    x2: 30.481,
    y2: 22.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4.05994,
    y1: 15.7734,
    x2: 19.981,
    y2: 22.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 4.15332,
    y1: 5.26074,
    x2: 13.4057,
    y2: 14.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 14.6067,
    y1: 5.27344,
    x2: 23.8467,
    y2: 14.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0,
    y1: 0,
    x2: 38.7692,
    y2: 25.8462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindow2);
export default __webpack_public_path__ + "static/media/icon-window2.bd017258d13622b511053e76d306e0dc.svg";
export { ForwardRef as ReactComponent };